import { render, staticRenderFns } from "./ButtonWithLabel.vue?vue&type=template&id=15621d41&scoped=true"
import script from "./ButtonWithLabel.vue?vue&type=script&lang=js"
export * from "./ButtonWithLabel.vue?vue&type=script&lang=js"
import style0 from "./ButtonWithLabel.vue?vue&type=style&index=0&id=15621d41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15621d41",
  null
  
)

export default component.exports